module.exports = __webpack_public_path__ + "static/img/ie.110efbf8.svg";